import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from '../../global.service';

@Component({
  selector: 'app-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.sass']
})
export class CollapseComponent implements OnInit {
  @Input() content: any;
  @Input() color;
  data : ContentItem[] = [];
  constructor(private global: GlobalService) {
  }

  ngOnInit() {
    this.data = this.content.content;
  }

  updateExpand(index) {
    if (this.global.validateSession() === true) {
      let content: any = this.content;
      content.content[index].expand = !content.content[index].expand;
    }
  }
}

export interface ContentItem {
  title: string;
  description: string;
  link1?: string;
  link1text?: string;
  description2?: string;
  expand: boolean
}

